import { useTranslation } from 'react-i18next';
import dashboardHero from '../../assets/dashboard-hero-focused.png';
import dashboardHeroEN from '../../assets/dashboard-hero-focused-en.png';
import dashboardSidebar from '../../assets/dashboard-sidebar.png';
import dashboardSidebarEN from '../../assets/dashboard-sidebar-en.png';
import expensesImage from '../../assets/expenses.png';
import expensesImageEN from '../../assets/expenses-en.png';
import investmentsImage from '../../assets/investments.png';
import investmentsImageEN from '../../assets/investments-en.png';
import analyticsFocused from '../../assets/analytics-focused.png';
import analyticsFocusedEN from '../../assets/analytics-focused-en.png';
import analyticsBarras from '../../assets/analytics-barras.png';
import analyticsBarrasEN from '../../assets/analytics-barras-en.png';
import analyticsPizza from '../../assets/analytics-pizza.png';
import analyticsPizzaEN from '../../assets/analytics-pizza-en.png';
import objectiveContributionImage from '../../assets/objective-contribution.png';
import objectiveContributionImageEN from '../../assets/objective-contribution-en.png';
import sharedExpensesImage from '../../assets/shared-expenses.png';
import sharedExpensesImageEN from '../../assets/shared-expenses-en.png';

import { Footer } from '../../components/Footer';
import { Benefits } from '../../components/landing/Benefits';
import { Features } from '../../components/landing/Features';
import { Hero } from '../../components/landing/Hero';
import { Plans } from '../../components/landing/Plans';
import { CTA } from '../../components/landing/CTA';
import { HowItWorks } from '../../components/landing/HowItWorks';

const imageByLanguage = (lang) => {
  const isPt = lang === 'pt';
  return {
    dashboardHero: isPt ? dashboardHero : dashboardHeroEN,
    dashboardSidebar: isPt ? dashboardSidebar : dashboardSidebarEN,
    expenses: isPt ? expensesImage : expensesImageEN,
    investments: isPt ? investmentsImage : investmentsImageEN,
    objective: isPt ? objectiveContributionImage : objectiveContributionImageEN,
    shared: isPt ? sharedExpensesImage : sharedExpensesImageEN,
    analyticsFocused: isPt ? analyticsFocused : analyticsFocusedEN,
    analyticsBarras: isPt ? analyticsBarras : analyticsBarrasEN,
    analyticsPizza: isPt ? analyticsPizza : analyticsPizzaEN,
  };
};

const SLIDE_IMAGE_MAP = {
  barras: 'analyticsBarras',
  pizza: 'analyticsPizza',
  focused: 'analyticsFocused',
};

export default function Landing() {
  const { t, i18n } = useTranslation('landing');
  const lang = i18n.language;
  const images = imageByLanguage(lang);

  const copy = {
    hero: t('hero', { returnObjects: true }),
    howItWorks: t('howItWorks', { returnObjects: true }),
    benefits: t('benefits', { returnObjects: true }),
    features: t('features', { returnObjects: true }),
    plans: t('plans', { returnObjects: true }),
    cta: t('cta', { returnObjects: true }),
  };

  const slidesRaw = t('analyticsSlides', { returnObjects: true }) || [];
  const analyticsSlides = slidesRaw.map((slide) => ({
    ...slide,
    image: images[SLIDE_IMAGE_MAP[slide.imageKey]],
  }));

  const benefits = copy.benefits.items.map((item, index) => {
    const imageKeys = ['expenses', 'investments', 'objective', 'shared'];
    return {
      ...item,
      image: {
        src: images[imageKeys[index]],
        alt: item.imageAlt,
      },
    };
  });

  const featureCopy = {
    ...copy.features,
    analytics: {
      ...copy.features.analytics,
      image: {
        src: images.analyticsFocused,
        alt: copy.features.analytics.imageAlt,
      },
    },
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Hero
        copy={copy}
        heroImage={{
          src: images.dashboardHero,
          alt: copy.hero.imageAlt,
        }}
      />

      <HowItWorks copy={copy.howItWorks} />

      <main className="mx-auto max-w-7xl space-y-10 px-4 py-10 sm:px-6 lg:space-y-14 lg:px-8 lg:py-14">
        <Benefits copy={copy.benefits} benefits={benefits} />
        <Features
          copy={featureCopy}
          analyticsSlides={analyticsSlides}
          sidebarImage={{
            src: images.dashboardSidebar,
            alt: t('sidebarBlockAlt'),
          }}
        />

        <Plans copy={copy.plans} />
        <CTA copy={copy.cta} />
      </main>

      <Footer />
    </div>
  );
}
